export default function title(title) {
  return `${title}`;
}
